import React from "react"
import { useStats } from "react-instantsearch"

const connectStats = (Component: any) => {
  const Stats = (props: any) => {
    const data = useStats()

    return <Component {...props} {...data} />
  }

  return Stats
}

const MyStats = ({ resultsText, currentRefinement } : { resultsText: string, currentRefinement: string }) => {
  const { nbHits } = useStats();
  const updatedText = resultsText?.replace("{x}", nbHits.toString())?.replace("{query}", currentRefinement)
  return (
    <h2 className="product-finder__stats">
      <span className="product-finder__stats__text">
        {updatedText}
      </span>
    </h2>
  )
}

const CustomStats = connectStats(MyStats)

export default CustomStats
